<template>
  <div class="sys-users-page">
    <el-card class="org-container">
      <div class="org-card">
        <el-card class="box-tree">
          <div class="div-scroll">
            <el-tree
              :data="treeData"
              :props="tree.props"
              @node-click="handleNodeClick"
            ></el-tree>
          </div>
        </el-card>
        <div class="table-container">
          <CCollapseItem>
            <template slot="title-left"> 用户管理 </template>
            <template slot="body">
              <c-search
                v-model="pageParams"
                :searchItems="searchItems"
                @reset="refresh"
                @search="pageGet(true)"
              >
              </c-search>
            </template>
          </CCollapseItem>
          <el-card class="box-table">
            <div slot="header" class="btn-group">
              <!-- 操作按钮 -->
              <div class="btn-left">
                <div class="opt-btn" title="新增" @click="goto('', 'add')">
                  <i class="iconfont icon-add"></i>
                </div>
              </div>
              <!-- 右侧操作按钮 -->
              <table-btns
                :tableColumns="tableColumns"
                @tableColumnsChange="tableColumnsChange"
                @refresh="pageGet(true)"
              ></table-btns>
            </div>
            <c-table
              :data="pageData"
              :index="true"
              :tableColumns="tableColumns"
              :pagination="pageParams"
              @change="pageGet"
              @selectionChange="selectionChange"
              v-loading="pageLoading"
            >
              <template slot="custom" slot-scope="scope">
                <div class="contr-btn-group users-btn-group">
                  <div class="sub-btn-group">
                    <div
                      class="contr-btn"
                      title="编辑"
                      @click="goto(scope.row, 'edit')"
                    >
                      <i class="iconfont icon-edit"></i>
                    </div>
                    <div
                      class="contr-btn"
                      title="授权"
                      @click="handleToAuthorization(scope.row)"
                    >
                      <i class="iconfont icon-authoration"></i>
                    </div>
                    <div
                      class="contr-btn"
                      title="重置密码"
                      @click="gotoResetPwd(scope.row)"
                    >
                      <i class="iconfont icon-password"></i>
                    </div>
                    <div
                      class="contr-btn"
                      @click="pageDel(scope.row.id)"
                      title="删除"
                    >
                      <i class="iconfont icon-shanchu"></i>
                    </div>
                    <div
                      class="contr-btn"
                      @click="handleUpdateStatus(scope.row)"
                      :title="scope.row.status == 1 ? '禁用' : '启用'"
                    >
                      <i
                        class="iconfont icon-qiyongyonghu"
                        v-if="scope.row.status == 0"
                      ></i>
                      <i
                        class="iconfont icon-jinyongyonghu"
                        v-if="scope.row.status == 1"
                      ></i>
                    </div>
                  </div>
                  <div class="contr-btn sub-btn-single">
                    <i
                      :title="
                        scope.row.isDesensitize == 1 ? '取消脱敏' : '数据脱敏'
                      "
                      class="iconfont icon-mingan icon-mingan-1"
                      :class="{
                        'icon-mingan-1': scope.row.isDesensitize == 1,
                        'icon-mingan-0': scope.row.isDesensitize == 0,
                      }"
                      v-if="scope.row.category == 'teacher'"
                      @click="handleDesensitization(scope.row)"
                    ></i>
                  </div>
                </div>
              </template>
            </c-table>
          </el-card>
        </div>
      </div>
    </el-card>
    <!-- 新增弹框 -->
    <el-dialog
      :close-on-click-modal="false"
      title="新增"
      :visible.sync="dialogAddFormVisible"
      @close="handleDialogClose"
    >
      <div class="div-scroll" style="max-height: 500px">
        <c-form
          v-model="handleData"
          :formRules="formRulesAdd"
          label-width="150px"
          ref="cForm"
          @submit="submit"
          @resetFields="resetFields"
        >
          <el-form-item label="所属部门" prop="orgId">
            <select-tree
              v-model.trim="handleData.orgId"
              :options="treeData"
              :props="tree.props"
            />
          </el-form-item>
          <c-form-item :formItems="formItemsAdd" />
        </c-form>
      </div>
    </el-dialog>
    <!-- 编辑弹框 -->
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogEditFormVisible"
      title="编辑"
    >
      <div class="div-scroll" style="max-height: 500px">
        <c-form
          v-model="handleData"
          :formRules="formRulesEdit"
          label-width="150px"
          ref="cForm"
          @submit="submit"
          @resetFields="resetFields"
        >
          <el-form-item label="所属部门" prop="orgId">
            <select-tree
              v-model="handleData.orgId"
              :options="treeData"
              :props="tree.props"
            />
          </el-form-item>
          <c-form-item :formItems="formItemsEdit" />
        </c-form>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogPwdFormVisible"
      title="重置密码"
    >
      <div class="div-scroll" style="max-height: 500px">
        <c-form
          v-model="pwdData"
          :formItems="formItemsPwd"
          :formRules="formRulesPwd"
          label-width="150px"
          ref="pForm"
          @submit="resetPwd"
          @resetFields="resetFields"
        ></c-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MPage from "@/mixins/MPage.js";
import MHandle from "@/mixins/MHandle.js";
import Configs from "./data/users";
import SelectTree from "@/components/SelectTree";
import { hex_sha1 } from "@/libs/sha1.js";
import { mapState } from "vuex";
let mPage = MPage({
  pagePath: "/account/sys/user/list",
  pageDelPath: "/account/sys/user/delete",
  pageDelsPath: "",
  pageParams: {
    platform: "",
  },
});
let mHandle = MHandle({
  handleGetPath: "",
  handleInsertPath: "/account/sys/user/save",
  handleUpdatePath: "/account/sys/user/update",
  handleDownLoadPath: "",
  handleData: {},
});
export default {
  mixins: [mPage, mHandle],
  components: { SelectTree },
  data() {
    let {
      searchItems,
      tableColumns,
      formItemsAdd,
      formItemsEdit,
      formRulesAdd,
      formRulesEdit,
      formItemsPwd,
      formRulesPwd,
      tree,
    } = Configs(this);
    return {
      isFold: false,
      searchItems,
      tableColumns,
      formItemsAdd,
      formItemsEdit,
      formItemsPwd,
      formRulesPwd,
      tree,
      formRulesAdd,
      formRulesEdit,
      idList: [],
      treeData: [],
      title: "",
      dialogAddFormVisible: false, // 新增弹框
      dialogEditFormVisible: false, // 编辑弹框
      dialogPwdFormVisible: false, // 修改密码弹框
      defaultHanldeData: {
        id: "",
        category: "", // 用户分类
        name: "", // 姓名
        number: "", // 编号
        orgId: "", // 所属部门
        password: "", // 密码
        phoneNumber: "", // 联系电话
        sex: "", // 性别
        status: "",
        username: "", // 用户名
        verifyPassword: "", // 校验密码
        numberzs: "",
      },
      pwdData: {
        userId: "",
        username: "",
        password: "",
        verifyPassword: "",
      },
      type: "", // 当前类型（新增或编辑）
    };
  },
  computed: {
    ...mapState("dic", ["SUCCESS_CODE", "_APP_KEY"]),
  },
  created() {
    this.getTreeData();
    this.getRoleList();
  },
  mounted() {},
  methods: {
    pageGetBeforeFn(data) {
      data.platform = this._APP_KEY;
      return data;
    },
    // 获取完整角色列表
    getRoleList() {
      this.$http.get("/account/sys/role/listAll").then((res) => {
        if (res.code == this.SUCCESS_CODE) {
          this.searchItems[1].options = res.data.map((item) => {
            return {
              label: item.name,
              value: item.id,
            };
          });
        }
      });
    },
    goto(data, type = "edit") {
      this.type = type;
      let id = data.id;
      this.handleData = Object.assign({}, this.defaultHanldeData);
      console.log(this.handleData);
      if (id) {
        console.log(data);
        this.dialogEditFormVisible = true;
        this.handleData = Object.assign({}, data);
      } else {
        this.dialogAddFormVisible = true;
      }
    },
    gotoResetPwd(data) {
      (this.pwdData = {
        userId: data.id,
        username: data.username,
        password: "",
        verifyPassword: "",
      }),
        (this.dialogPwdFormVisible = true);
    },
    // 重置用户密码
    resetPwd() {
      this.pwdData.password = hex_sha1(this.pwdData.password);
      this.pwdData.verifyPassword = hex_sha1(this.pwdData.verifyPassword);
      this.$http
        .post("/account//sys/user/resetPwd", this.pwdData)
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            this.dialogPwdFormVisible = false;
            this.$message.success(res.msg);
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    selectionChange(data) {
      let idList = [];
      if (data.length) {
        data.forEach((item) => {
          idList.push(item.id);
        });
        this.idList = idList;
      }
    },
    handleDelBatch() {
      if (this.idList.length) {
        this.pageDels(this.idList);
      } else {
        this.$message({
          message: "请选择需要删除的数据！",
          type: "warning",
        });
      }
    },
    pageDelAfterFn() {
      this.idList = [];
      this.pageGet(true);
    },
    refresh() {
      this.pageParams = {};
      this.pageGet(true);
    },
    tableColumnsChange(data) {
      let self = this;
      self.tableColumns.forEach((item) => {
        if (data.indexOf(item.prop) == -1) {
          item.show = false;
        } else {
          item.show = true;
        }
      });
    },
    // 点击树节点
    handleNodeClick(data) {
      console.log(data);
      this.pageParams.orgId = data.id;
      this.pageGet(true);
    },
    // 获取树节点数据
    getTreeData() {
      this.$http.get("/account/sys/org/getOrgTree").then((res) => {
        console.log(res);
        if (res.code == this.SUCCESS_CODE) {
          this.treeData = res.data;
        }
      });
    },
    submit() {
      if (this.handleData.id) {
        // console.log("编辑");
        this.handleUpdate();
      } else {
        // console.log("新增");
        this.handleInsert();
      }
    },
    resetFields() {
      this.dialogEditFormVisible = false;
      this.dialogAddFormVisible = false;
      this.dialogPwdFormVisible = false;
    },
    handleDialogClose() {
      // this.$nextTick(() => {
      //   this.$refs.cForm.resetFields();
      // });
      // this.handleData = Object.assign({}, this.defaultHanldeData);
      // this.dialogFormVisible = false;
    },
    handleBeforeFn() {
      if (this.type == "add") {
        // 密码加密
        this.handleData.password = hex_sha1(this.handleData.password);
        this.handleData.verifyPassword = hex_sha1(
          this.handleData.verifyPassword
        );
      }
    },
    handleAfterFn() {
      this.dialogEditFormVisible = false;
      this.dialogAddFormVisible = false;
      this.pageGet(true);
    },
    // 跳转到授权页面
    handleToAuthorization(data) {
      let id = data.id;
      this.$router.push("/sys/users/authorization/" + id);
    },
    // 脱敏信息查看
    handleDesensitization(data) {
      // isDesensitize是否脱敏，1是0否
      let msg =
        data.isDesensitize == 0
          ? "该操作将对数据脱敏，是否继续？"
          : "该操作将取消数据脱敏，是否继续？";
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        let isDesensitize = data.isDesensitize == 0 ? 1 : 0;
        console.log(data);
        let params = {
          id: data.id,
          isDesensitize,
        };
        this.$http
          .post("/account/sys/user/updateDesensitize", params)
          .then((res) => {
            if (res.code == this.SUCCESS_CODE) {
              this.$message.success(res.msg);
              this.pageGet(true);
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch((err) => {
            this.$message.error("操作失败" + err);
          });
      });
    },
    // 启用、禁用用户
    handleUpdateStatus(data) {
      let msg =
        data.status == 0
          ? "该操作将启用该用户，是否继续？"
          : "该操作将禁用该用户，是否继续？";
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        let status = data.status == 0 ? 1 : 0;
        let params = {
          id: data.id,
          status,
        };
        this.$http
          .post("/account/sys/user/updateStatus", params)
          .then((res) => {
            if (res.code == this.SUCCESS_CODE) {
              this.$message.success(res.msg);
              this.pageGet(true);
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch((err) => {
            this.$message.error("操作失败" + err);
          });
      });
    },
  },
};
</script>
